import { useEffect, useState } from "react";
import SteminpeLeaderboard from "./SteminpeLeaderboard";
import { LeaderboardApi } from "../../api/LeaderboardApi";

const leaderboardInfo = {
    heading: "STEAMinPE比賽",
    subHeading: "共創運動紀錄大獎",
    unit: "",
};


const SteminpeLeaderboardTopPlaySchool = () => {
    const [leaderboardData, setLeaderboardData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchLeaderboard = async () => {
        try {
            setIsLoading(true);
            const result = await LeaderboardApi.getTopOrgPlayTime();
            const transformed = (result ?? []).map(
                ({ id, rank, name_zh, total_duration, format_total_duration }) => ({
                    id,
                    rank,
                    itemName: name_zh,
                    score: total_duration,
                    formattedScore: format_total_duration,
                })
            );
            // setIsLoading(false);
            setLeaderboardData(transformed);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchLeaderboard();
    }, []);

    return (
        <>
            {/* <pre>
                {JSON.stringify(leaderboardData, null, 2)}
            </pre> */}
            <SteminpeLeaderboard
                leaderboardInfo={leaderboardInfo}
                leaderboardData={leaderboardData}
                isLoading={isLoading}
            />
        </>
    );
};

export default SteminpeLeaderboardTopPlaySchool;